// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_divider__phDob {
  margin: 5px auto;
  width: 100%;
  background-color: #fafafa;
  border-top: 1px solid #eeeeee;
  display: block;
}

@media only screen and (max-width: 800px) {
  .styles_divider__phDob {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/Divider/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,6BAAA;EACA,cAAA;AACF;;AAGA;EAEE;IACE,aAAA;EADF;AACF","sourcesContent":[".divider {\n  margin: 5px auto;\n  width: 100%;\n  background-color: #fafafa;\n  border-top: 1px solid #eeeeee;\n  display: block;\n}\n\n// @media only screen and (max-width: 576px) {\n@media only screen and (max-width: 800px) {\n\n  .divider {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": `styles_divider__phDob`
};
export default ___CSS_LOADER_EXPORT___;
